
import {map} from 'rxjs/operators';
import { Injector, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AssociationController } from 'src/features/common/association/association.controller';
import { ApiHelper } from 'cad/common/services/api/api-helper';
import { AssociationApi } from 'src/features/common/association/association-api';
import { BAContactData } from 'cad/data-administration/shared/interfaces/ba-contact';

@Injectable()
export class AssociateBusinessAssociateContactExternalApi implements AssociationApi {
  public endpoint: string = 'associate/business-associate/';
  public suffix: string = '/default-roles';

  static createAssociationApi(
    apiHelper: ApiHelper,
    associationController: AssociationController,
    injector: Injector,
  ): AssociationApi {
    return new AssociateBusinessAssociateContactExternalApi(apiHelper);
  }

  constructor(
    private apiHelper: ApiHelper,
  ) {}

  public findAll = (baId: string | number): Observable<any> => {
    return this.apiHelper.request(this.endpoint + baId + this.suffix + '/external').pipe(map((items) => {
      return this.appendRollType(items);
    }));
  }

  public filter(baId: string | number, baContactFilter: Partial<BAContactData>): Observable<BAContactData[]> {
    return this.apiHelper.request(this.endpoint + baId + this.suffix + '/external', { body: baContactFilter })
      .pipe(map((baContactList: BAContactData[]) => {
        return this.appendRollType(baContactList);
      }));
  }

  public save = (dataList: any[]): Observable<any> => {
    return this.apiHelper.request(this.endpoint + (dataList[ 0 ].serviceRequestorBaId
      ? dataList[ 0 ].serviceRequestorBaId
      : dataList[ 0 ].baId) + this.suffix, { body: dataList });
  }

  // Helpers
  private appendRollType = (items: any): any => {
    return _.each(items, (item) => {
      item.roleType = 'external';
    });
  }
}
